module.exports = __webpack_public_path__ + "static/pavan-d0b5fd798f455a5fbee5416124f474a8.jpg";